import React, { useEffect, useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
//import Questions from '../Database/Questions';
import AllQuestions from '../AllData/AllQuestions';
import Loading from '../home/Loading';
import './../../pagescss/BookMarkedQuestions.css';
import Latex from 'react-latex';
import TopNavbar from '../home/TopNavbar';
import TopHeader from '../home/TopHeader';
import QuestionImage from './QuestionImage';


const QuestionHistory = () => {
    const [savedQuestions, setSavedQuestions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedSubject, setSelectedSubject] = useState('All');
    const [currentPage, setCurrentPage] = useState(1);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const itemsPerPage = 10;


    // const { questions } = Questions();
    const questions = AllQuestions;
    // Load saved question IDs on component mount
    useEffect(() => {
        const storedQuestions = JSON.parse(localStorage.getItem('saveQuestionsIdInLocalStorage')) || [];
        setSavedQuestions(storedQuestions);
        setLoading(false);
    }, []);



    // Get all unique subjects from saved questions
    const getSubjects = () => {
        const subjects = new Set(['All']);
        questions.forEach(q => {
            if (savedQuestions.includes(q._id.$oid) && q.subject) {
                subjects.add(q.subject);
            }
        });
        return Array.from(subjects);
    };

    // Filter questions to only show saved ones and apply subject filter
    const filteredQuestions = useMemo(() => {
        // Create a map for quick question lookup
        const questionMap = {};
        questions.forEach(q => {
            questionMap[q._id.$oid] = q;
        });

        // Get questions in the order they were saved (newest first)
        const savedQuestionsInOrder = [];
        for (let i = savedQuestions.length - 1; i >= 0; i--) {
            const questionId = savedQuestions[i];
            const question = questionMap[questionId];
            if (question) {
                savedQuestionsInOrder.push(question);
            }
        }

        // Apply subject filter if needed
        if (selectedSubject !== 'All') {
            return savedQuestionsInOrder.filter(question =>
                question.subject === selectedSubject
            );
        }

        return savedQuestionsInOrder;
    }, [questions, savedQuestions, selectedSubject]);

    const totalPages = Math.ceil(filteredQuestions.length / itemsPerPage);
    const currentQuestions = filteredQuestions.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Function to render text with LaTeX
    const renderWithLatex = (text) => {
        if (!text) return null;

        // Check if text contains LaTeX patterns
        if (text.includes('$') || text.includes('\\')) {
            return <Latex>{text}</Latex>;
        }
        return text;
    };

    if (loading) {
        return <Loading message='Loading history...' />;
    }

    return (
        <div className="bookmarked-container">


            <TopNavbar name={"Your Saved Questions " + "(" + filteredQuestions.length + ")"} />
            <TopHeader name={"Your Saved Questions " + "(" + filteredQuestions.length + ")"} />






            {filteredQuestions.length > 0 && (
                <div className="filter-controls">
                    {getSubjects().map(subject => (
                        <button
                            key={subject}
                            className={`filter-btn ${selectedSubject === subject ? 'active' : ''}`}
                            onClick={() => {
                                setSelectedSubject(subject);
                                setCurrentPage(1); // Reset to first page when filtering
                            }}
                        >
                            <p>{subject}</p>
                        </button>
                    ))}
                </div>
            )}



            {filteredQuestions.length === 0 ? (
                <div className="empty-state">
                    {savedQuestions.length === 0 ? (
                        <>
                            <div className="empty-icon">
                                <i className="far fa-bookmark" style={{ fontSize: '3rem', color: '#7f8c8d', marginBottom: '1rem' }}></i>
                            </div>
                            <h3 className="empty-message">No Practics Questions Yet</h3>
                            <p className="empty-message">Questions you practics will appear here</p>
                            <Link to="/practice-questions" className="browse-link">
                                Start Practicing Now
                            </Link>
                        </>
                    ) : (
                        <>
                            <div className="empty-icon">
                                <i className="far fa-folder-open" style={{ fontSize: '3rem', color: '#7f8c8d', marginBottom: '1rem' }}></i>
                            </div>
                            <h3 className="empty-message">No Questions Found</h3>
                            <p className="empty-message">No questions match the selected subject</p>
                            <button
                                className="browse-link"
                                onClick={() => setSelectedSubject('All')}
                                style={{ cursor: 'pointer' }}
                            >
                                Show All Questions
                            </button>
                        </>
                    )}
                </div>
            ) : (
                <>
                    <div className="items-list">
                        {currentQuestions.map((item, index) => (
                            <div key={item._id} className="item-card">
                                <div className="item-content">
                                    <span className="item-index">🕒({((currentPage - 1) * itemsPerPage) + index + 1}) </span>
                                    <div>
                                        <Link
                                            to={`/question-solution/${item._id.$oid}`}
                                            className="item-text"
                                            style={{ textDecoration: 'none', color: 'inherit' }}
                                        >

                                            {item.type === "dpp" ? (<>
                                                {item.question ? (
                                                    <p className="question-text">
                                                        {renderWithLatex(item.question)}
                                                    </p>
                                                ) : (
                                                     <QuestionImage
                                                        src={`/questionsPhoto/${item.question_img}`}
                                                        alt="Question"
                                                    />
                                                )}
                                            </>) : (<>
                                                {item.question_img ? (
                                                    <QuestionImage
                                                        src={`/questionsPhoto/${item.question_img}`}
                                                        alt="Question"
                                                    />
                                                ) : (
                                                    <>{renderWithLatex(item.question)}</>
                                                )}
                                            </>)}







                                            <div className="item-meta">
                                                <span>
                                                    <i className="fas fa-book" style={{ marginRight: '5px' }}></i>
                                                    {item.subject || 'No subject'}
                                                </span>
                                                {item.topicname && (
                                                    <span style={{ marginLeft: '1rem' }}>
                                                        <i className="fas fa-tag" style={{ marginRight: '5px' }}></i>
                                                        {item.topicname}
                                                    </span>
                                                )}
                                            </div>

                                        </Link>

                                    </div>
                                </div>
                                <div className="item-actions">
                                    <Link
                                        to={`/question-solution/${item._id.$oid}`}
                                        className="action-btn view-btn"
                                    >

                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>

                </>
            )}


            {filteredQuestions.length > 10 ? (<>

                <div className="pagination-controls">
                    <div className="pagination-info">
                        Showing {((currentPage - 1) * itemsPerPage) + 1}-{Math.min(currentPage * itemsPerPage, filteredQuestions.length)} of {filteredQuestions.length} questions
                    </div>
                    <div className="pagination-buttons">
                        <button
                            className="pagination-btn"
                            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                            disabled={currentPage === 1}
                        >
                            <i className="fas fa-chevron-left"></i> Previous
                        </button>
                        <button
                            className="pagination-btn"
                            onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                            disabled={currentPage === totalPages}
                        >
                            Next <i className="fas fa-chevron-right"></i>
                        </button>
                    </div>
                </div>

            </>) : (<></>)}


        </div>
    );
};

export default QuestionHistory;